import React from "react";
import Loader from '../../../components/Loader';
import Page from '../../../components/Page';
import HTTPManager from "../../../utils/httpRequestManager";
import TableView from '../../../components/table/tableView';
import { toast, ToastContainer } from 'react-toastify';
import Iconify from '../../../components/Iconify';
import FormManager from "../../../components/formComponents/FormManager";
import schema from './schema.json';
import {Box, Grid, Card,  Container, Typography, Stack, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button} from '@mui/material';
import FButton from '../../../components/formComponents/components/button';
import { checkButtonAccess } from "../../../utils/protector";
const getIcon = (name) => <Iconify icon={name} width={22} height={22} />;

export default class Employee extends React.Component{
    httpManager = new HTTPManager();

    constructor(){
        super();
        this.state={
            isLoading:false,
            schema:{},
            roleList:[],
            addForm: false,
            selectedRole:{},
            defaultcommission:{},
            openDialog: false,
            columns:[
                {
                    field: 'roleName',
                    headerName: 'Name',
                    minWidth:200,
                    editable: false,
                    renderCell: (params) => (
                        <div style={{position:'relative', height:'100%', paddingLeft:'20px', display:'flex', alignItems:'center', marginLeft:'-10px'}}>
                        {params.row.roleName }
                        </div>
                    )
                }, 
                {
                    field: 'Action',
                    headerName:'Actions',
                    flex:1,
                    minWidth:100,
                    renderCell: (params) => (
                        this.getActions(params)                    
                    ),
                }
            ]
        }
        this.handleCloseform = this.handleCloseform.bind(this); 
        this.updateRecord = this.updateRecord.bind(this); 
    }
    updateRecord(row, status){ 
        this.setState({isLoading: true}, ()=>{
            this.httpManager.postRequest(`merchant/employee/update`, {mEmployeeStatus: status, id: row.mEmployeeId}).then(res=>{
                //console.log(res.message);
                this.setState({isLoading: false});
                this.reloadData(res.message);
            })
        })
    }

    getPasscode(row){
        var detail = window.localStorage.getItem('userdetail')
        if(detail !== '' && detail !== undefined && detail !=='{}'){
          var userdetail = JSON.parse(detail);
            if(userdetail.userRole === 'Owner' && row.mEmployeeRoleName === 'Owner'){
                return row.mEmployeeCode
            }
            else if(userdetail.userRole !== 'Owner' && row.mEmployeeRoleName === 'Owner'){
                return '****'
            }
            else{
                return row.mEmployeeCode;
            }
        }
        return ''
    }

    getActions(params){
        var detail = window.localStorage.getItem('userdetail')
        if(detail !== '' && detail !== undefined && detail !=='{}'){
          var userdetail = JSON.parse(detail);
        return <div>       
            {( userdetail.userRole==='Owner')&&  <FButton
                variant="outlined" 
                size="small" 
                onClick={()=>this.openEdit(params.row)} 
                label="Edit"/>}

            {userdetail.userRole !=='Owner' && <div>N/A</div>}
            
            </div>
        }
    }
    componentDidMount(){ 
        this.setState({schema: schema},()=>{
            this.reloadData();
        })
    }
    handleCloseform(){
        this.setState({addForm: false})
    }
    openEdit(data){  
        var properties = Object.assign([], schema.properties);
        var props=[];
  
        properties.forEach((field,i)=>{
            field.value = data[field.name]; 
            if(field.component !== 'Permission'){
                props.push(field);
            } 
            if(i === properties.length-1){ 
                    console.log(data)
                props.push( {
                    "component":"Permission", 
                    "permissionType": "Admin",
                    style:{display:'flex'},
                    "value" : JSON.parse(data["rolePermissions"]),
                    "permissions":[
                        {
                            key:"Employee",
                            label:"Employee Management",
                            options:[
                                {
                                    "label":"Read",
                                    "Value" :"R"
                                },
                                {
                                    "label":"Write",
                                    "Value" :"W"
                                }
                            ]
                        },
                        {
                            key:"Customer",
                            label:"Customer Management", 
                            options:[
                                {
                                    "label":"Read",
                                    "Value" :"R"
                                },
                                {
                                    "label":"Write",
                                    "Value" :"W"
                                }
                            ]
                        },
                        {
                            key:"Inventory",
                            label:"Inventory Management", 
                            options:[
                                {
                                    "label":"Read",
                                    "Value" :"R"
                                },
                                {
                                    "label":"Write",
                                    "Value" :"W"
                                }
                            ]
                        },
                        {
                            key:"GiftCard",
                            label:"GiftCard Management", 
                            options:[
                                {
                                    "label":"Read",
                                    "Value" :"R"
                                },
                                {
                                    "label":"Write",
                                    "Value" :"W"
                                }
                            ]
                        }, 
                        {
                            key:"DefaultCommission",
                            label:"Default Commission Management", 
                            options:[
                                {
                                    "label":"Read",
                                    "Value" :"R"
                                },
                                {
                                    "label":"Write",
                                    "Value" :"W"
                                }
                            ]
                        }, 
                        {
                            key:"DefaultDiscount",
                            label:"Default Discount Management", 
                            options:[
                                {
                                    "label":"Read",
                                    "Value" :"R"
                                },
                                {
                                    "label":"Write",
                                    "Value" :"W"
                                }
                            ]
                        }, 
                        {
                            key:"Discount",
                            label:"Discount Management", 
                            options:[
                                {
                                    "label":"Read",
                                    "Value" :"R"
                                },
                                {
                                    "label":"Write",
                                    "Value" :"W"
                                }
                            ]
                        }, 
                        {
                            key:"Tax",
                            label:"Tax Management", 
                            options:[
                                {
                                    "label":"Read",
                                    "Value" :"R"
                                },
                                {
                                    "label":"Write",
                                    "Value" :"W"
                                }
                            ]
                        }, 
                        {
                            key:"EmpSettings",
                            label:"Employee Specific Settings", 
                            options:[
                                {
                                    "label":"Read",
                                    "Value" :"R"
                                },
                                {
                                    "label":"Write",
                                    "Value" :"W"
                                }
                            ]
                        },
                        {
                            key:"LoyaltyPoints",
                            label:"Loyalty Points", 
                            options:[
                                {
                                    "label":"Read",
                                    "Value" :"R"
                                },
                                {
                                    "label":"Write",
                                    "Value" :"W"
                                }
                            ]
                        },  
                        {
                            key:"Transactions",
                            label:"Transactions", 
                            options:[
                                {
                                    "label":"Read",
                                    "Value" :"R"
                                }
                            ]
                        }, 
                        {
                            key:"Payout",
                            label:"Payout Management", 
                            options:[
                                {
                                    "label":"Read",
                                    "Value" :"R"
                                }, 
                                {
                                    "label":"Pay",
                                    "Value" :"W"
                                }, 
                            ]
                        }, 
                        {
                            key:"Report",
                            label:"Reports", 
                            options:[
                                {
                                    "label":"Read",
                                    "Value" :"R"
                                }, 
                            ]
                        },  
                    ]
                })  
                props.push({
                    "component":"TextField", 
                    "type": "hidden", 
                    "minLength": 1,
                    "maxLength": 50,
                    "grid":6,
                    "name":"roleId",
                    "label":"id",
                    "placeholder":"id",
                    "value":data.id
                  })
                schema.properties = props; 
                this.setState({schema: schema,selectedRole: data},()=>{
                    this.setState({addForm: true})
                })
            }
        })
    }
    reloadData(msg=''){
        if(msg !== ''){ 
            toast.dismiss();
            toast.success(msg, {
                position: "top-center",
                autoClose: 5000,
                closeButton:false,
                hideProgressBar: true,
                closeOnClick: false,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
        }
        this.setState({isLoading: true, addForm: false},()=>{
            this.httpManager.getRequest(`merchant/getRoles`).then(response=>{
                //console.log(response)
                this.setState({roleList: response.data, isLoading: false});
            })
        })
    } 

    handleCloseDialog(){
        this.setState({openDialog: false})
    }

    openAdd(){ 
        this.setState({schema: schema,selectedRole: {}},()=>{
            var schemaobj = Object.assign({}, schema);
            var properties = Object.assign([], this.state.schema.properties);
            var props=[];
            properties.forEach((field,i)=>{
                delete field["value"];
                field.disabled= false; 
                props.push(field);
                if(i === properties.length-1){
                    props.push( {
                        "component":"Permission", 
                        "permissionType":"Admin",
                        style:{'display':'flex'},
                        "permissions":[
                            {
                                key:"Employee",
                                label:"Employee Management",
                                options:[
                                    {
                                        "label":"Read",
                                        "Value" :"R"
                                    },
                                    {
                                        "label":"Write",
                                        "Value" :"W"
                                    }
                                ]
                            },
                            {
                                key:"Customer",
                                label:"Customer Management", 
                                options:[
                                    {
                                        "label":"Read",
                                        "Value" :"R"
                                    },
                                    {
                                        "label":"Write",
                                        "Value" :"W"
                                    }
                                ]
                            },
                            {
                                key:"Inventory",
                                label:"Inventory Management", 
                                options:[
                                    {
                                        "label":"Read",
                                        "Value" :"R"
                                    },
                                    {
                                        "label":"Write",
                                        "Value" :"W"
                                    }
                                ]
                            },
                            {
                                key:"GiftCard",
                                label:"GiftCard Management", 
                                options:[
                                    {
                                        "label":"Read",
                                        "Value" :"R"
                                    },
                                    {
                                        "label":"Write",
                                        "Value" :"W"
                                    }
                                ]
                            }, 
                            {
                                key:"DefaultCommission",
                                label:"Default Commission Management", 
                                options:[
                                    {
                                        "label":"Read",
                                        "Value" :"R"
                                    },
                                    {
                                        "label":"Write",
                                        "Value" :"W"
                                    }
                                ]
                            }, 
                            {
                                key:"DefaultDiscount",
                                label:"Default Discount Management", 
                                options:[
                                    {
                                        "label":"Read",
                                        "Value" :"R"
                                    },
                                    {
                                        "label":"Write",
                                        "Value" :"W"
                                    }
                                ]
                            }, 
                            {
                                key:"Discount",
                                label:"Discount Management", 
                                options:[
                                    {
                                        "label":"Read",
                                        "Value" :"R"
                                    },
                                    {
                                        "label":"Write",
                                        "Value" :"W"
                                    }
                                ]
                            }, 
                            {
                                key:"Tax",
                                label:"Tax Management", 
                                options:[
                                    {
                                        "label":"Read",
                                        "Value" :"R"
                                    },
                                    {
                                        "label":"Write",
                                        "Value" :"W"
                                    }
                                ]
                            }, 
                            {
                                key:"EmpSettings",
                                label:"Employee Specific Settings", 
                                options:[
                                    {
                                        "label":"Read",
                                        "Value" :"R"
                                    },
                                    {
                                        "label":"Write",
                                        "Value" :"W"
                                    }
                                ]
                            },
                            {
                                key:"LoyaltyPoints",
                                label:"Loyalty Points", 
                                options:[
                                    {
                                        "label":"Read",
                                        "Value" :"R"
                                    },
                                    {
                                        "label":"Write",
                                        "Value" :"W"
                                    }
                                ]
                            },  
                            {
                                key:"Transactions",
                                label:"Transactions", 
                                options:[
                                    {
                                        "label":"Read",
                                        "Value" :"R"
                                    }
                                ]
                            }, 
                            {
                                key:"Payout",
                                label:"Payout Management", 
                                options:[
                                    {
                                        "label":"Read",
                                        "Value" :"R"
                                    }, 
                                ]
                            }, 
                            {
                                key:"Report",
                                label:"Reports", 
                                options:[
                                    {
                                        "label":"Read",
                                        "Value" :"R"
                                    }, 
                                ]
                            },  
                        ]
                    })
                    schemaobj.properties = props;
                }
            });
            this.setState({schema:schemaobj}, ()=>{
                this.setState({addForm: true}) 
            })
        }) 
    }
    render(){
        return <Page title="Employees | Astro POS">
            {this.state.isLoading && <Loader show={this.state.isLoading} />}
            <ToastContainer
            position="top-center"
            autoClose={5000}
            hideProgressBar
            newestOnTop={false}
            closeOnClick={false}
            rtl={false}
            pauseOnFocusLoss={false}
            draggable={false}
            pauseOnHover={false}
            />
            {!this.state.addForm ? 
                <Container maxWidth="xl">
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                    <Typography variant="h4" gutterBottom>
                    Roles Management
                    </Typography>
                   {checkButtonAccess('Role') === 'W' && <FButton 
                    onClick={()=>this.openAdd()}
                    size="large"
                    variant="contained"
                    label="Add Role"
                    startIcon={getIcon('mdi:plus')}
                    />}
                </Stack>

                <Card>
                    <TableView
                    data={this.state.roleList} 
                    columns={this.state.columns} />
                </Card>
                </Container> : ''
            }
            {this.state.addForm && <Box sx={{ width: '100%' }}> 
                <Grid container spacing={3}  alignItems="center"  justifyContent="center" style={{marginLeft:0, marginRight:0,width:'100%', fontWeight:'bold'}} > 
                     <Grid item xs={12}> 
                        <Stack spacing={3}> 
                            <FormManager formProps={this.state.schema}  reloadData={(msg)=>this.reloadData(msg)} closeForm={()=>this.handleCloseform()}/>
                        </Stack>
                    </Grid>
                </Grid>
            </Box>}


            <Dialog
                    open={this.state.openDialog}
                    onClose={this.handleCloseDialog}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        Error
                    </DialogTitle>
                    <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                       Please set default commission and create employees.
                    </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button variant="outlined" onClick={()=>{
                            this.handleCloseDialog()
                        }}>  OK </Button> 
                    </DialogActions>
                </Dialog>

            </Page>  
    }


}